import BaseRequest from './BaseRequest';

const schema = 'authorization';

export default class AuthorizationRequest extends BaseRequest {
  fetchPermission(data) {
    const url = `${schema}/permissions/`;
    return this.post(url, data);
  }

  fetchGetPermissions(params) {
    const url = `${schema}/permissions/`;
    return this.get(url, params);
  }

  fetchPutPermission(params) {
    const url = `${schema}/permissions/`;
    return this.put(url, params);
  }

  fetchDeletePermission(params) {
    const url = `${schema}/permissions/${params.permissionId}/`;
    return this.del(url);
  }

  fetchGetRole(params) {
    const url = `${schema}/roles/`;
    return this.get(url, params);
  }

  fetchPostRole(params) {
    const url = `${schema}/roles/`;
    return this.post(url, params);
  }

  fetchPostAction(params) {
    const url = `${schema}/controls/`;
    return this.post(url, params);
  }

  fetchGetAction(params) {
    const url = `${schema}/controls/`;
    return this.get(url, params);
  }

  fetchDeleteAction(params) {
    const url = `${schema}/controls/${params.controlId}`;
    return this.del(url);
  }

  fetchGetPermissionsByRole(params) {
    const url = `${schema}/permissions/role/${params.roleId}/`;
    return this.get(url);
  }

  fetchGetActionByRoleAndPermission(params) {
    const url = `${schema}/role-perms-controls/role/${params.roleId}/permissionId/${params.permissionId}`;
    return this.get(url);
  }

  fetchPermCtrlByRole(params) {
    const url = `${schema}/roles/${params.roleId}/`;
    return this.get(url);
  }

  postPermissionControlForRole(params) {
    const url = `${schema}/role-permissions/multi`;
    return this.post(url, params);
  }

  fetchDeleteRole(params) {
    const url = `${schema}/roles/${params.roleId}`;
    return this.del(url);
  }

  fetchGetRoleByPubkey(params) {
    const url = `${schema}/role-users/${params.pubkey}`;
    return this.get(url);
  }

  fetchPostRoleForUser(params) {
    const url = `${schema}/role-users/multi`;
    return this.post(url, params);
  }
}
